import { useEffect, useState } from "react";

export function operationalToday(now = Date.now()) {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Argentina/Buenos_Aires", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(new Date(now));
  const value = (key) => parts.find((part) => part.type === key).value;
  return `${value("year")}-${value("month")}-${value("day")}`;
}
export function isClosedDay(day, today = operationalToday()) {
  const text = String(day || "").slice(0, 10);
  return /^\d{4}-\d{2}-\d{2}$/.test(text) && text < today;
}
export function useOperationalDay() {
  const [today, setToday] = useState(operationalToday);
  useEffect(() => {
    const refresh = () => setToday(operationalToday());
    const timer = setInterval(refresh, 30000);
    window.addEventListener("focus", refresh);
    return () => { clearInterval(timer); window.removeEventListener("focus", refresh); };
  }, []);
  return today;
}
